var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.692,
    height: 70.836,
    viewBox: "0 0 48.692 70.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-469.527 -158.881)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.527 226.188)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.219,245.86a1.764,1.764,0,0,1-1.764,1.765H471.292a1.764,1.764,0,0,1-1.765-1.765h0a1.764,1.764,0,0,1,1.765-1.765h45.163a1.764,1.764,0,0,1,1.764,1.765Z",
    transform: "translate(-469.527 -244.095)",
    fill: "#282538"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(470.288 158.881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.019,158.881H495.46c-1.8,0-3.252,2.339-3.252,5.224v16.251c0,2.885,1.456,5.225,3.252,5.225h5.559c1.8,0,3.251-2.34,3.251-5.225V164.105C504.27,161.22,502.814,158.881,501.019,158.881Zm2.07,19.247c0,2.095-1.17,3.793-2.615,3.793H496c-1.445,0-2.615-1.7-2.615-3.793v-11.8c0-2.095,1.171-3.792,2.615-3.792h4.47c1.445,0,2.615,1.7,2.615,3.792Z",
    transform: "translate(-475.055 -158.881)",
    fill: "#252e3f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.45,227.17V187.245a17.209,17.209,0,0,0-17.209-17.209H488.406A17.21,17.21,0,0,0,471.2,187.245V227.17a3.187,3.187,0,0,0,3.187,3.187h38.88A3.187,3.187,0,0,0,516.45,227.17Z",
    transform: "translate(-470.639 -167.308)",
    fill: "#252e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.86,225.123V184.215a17.633,17.633,0,0,0-17.633-17.633h-11.1a17.633,17.633,0,0,0-17.634,17.633v40.908a3.266,3.266,0,0,0,3.265,3.266h39.838A3.266,3.266,0,0,0,516.86,225.123Z",
    transform: "translate(-470.491 -166.582)",
    fill: "#3a4151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.86,185.938v-1.723a17.633,17.633,0,0,0-17.633-17.633h-11.1a17.633,17.633,0,0,0-17.634,17.633v1.723Z",
    transform: "translate(-470.491 -166.582)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.365,182.832h11.1a15.669,15.669,0,0,0,12.97-6.884,15.668,15.668,0,0,0-12.969-6.885h-11.1a15.67,15.67,0,0,0-12.97,6.885A15.668,15.668,0,0,0,489.365,182.832Z",
    transform: "translate(-471.731 -167.103)",
    fill: "#d8d8da",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.263,181.17a15.7,15.7,0,0,1,15.3-12.282h11.1a15.7,15.7,0,0,1,15.3,12.282h.667a16.354,16.354,0,0,0-15.97-12.935h-11.1A16.355,16.355,0,0,0,472.6,181.17Z",
    transform: "translate(-470.933 -166.929)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.369,
    height: 1.246,
    transform: "translate(0 18.657)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.862 23.927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.713,197.7h.836a2.069,2.069,0,0,0,2.066-2.066V192.55a.985.985,0,0,0-.983-.984h-3a.985.985,0,0,0-.984.984v3.082A2.069,2.069,0,0,0,478.713,197.7Zm-1.328-5.148a.245.245,0,0,1,.246-.246h3a.245.245,0,0,1,.246.246v3.082a1.328,1.328,0,0,1-1.329,1.328h-.836a1.328,1.328,0,0,1-1.328-1.328Z",
    transform: "translate(-476.647 -189.676)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.102,
    height: 2.939,
    fill: "#525568"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.815,197.7h.836a2.069,2.069,0,0,0,2.066-2.066V192.55a.985.985,0,0,0-.984-.984h-3a.985.985,0,0,0-.984.984v3.082A2.069,2.069,0,0,0,518.815,197.7Zm-1.328-5.148a.246.246,0,0,1,.246-.246h3a.246.246,0,0,1,.246.246v3.082a1.328,1.328,0,0,1-1.329,1.328h-.836a1.328,1.328,0,0,1-1.328-1.328Z",
    transform: "translate(-516.749 -189.676)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.915)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.102,
    height: 2.939,
    fill: "#525568"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.657 33.679)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.471,
    height: 0.49,
    transform: "translate(0.465 0.223)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.894,205.054l-.3-2.207h.254V201.52h-1.216v1.326h.254l-.3,2.207Z",
    transform: "translate(-472.589 -201.52)",
    fill: "#f1b14f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.746,202.758v-1.084H473.8Z",
    transform: "translate(-472.622 -201.553)",
    fill: "#d8d8da"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.419 19.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.593,187.278l-.3-2.207h.254v-1.327h-1.216v1.327h.254l-.3,2.207Z",
    transform: "translate(-472.288 -183.744)",
    fill: "#f1b14f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.445,184.982V183.9H473.5Z",
    transform: "translate(-472.321 -183.777)",
    fill: "#d8d8da"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.4daaf61f.svg";
export { ForwardRef as ReactComponent };